import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@mui/icons-material/Search';

const ContactsHeader = ({
  selectedListType,
  handleButtonClick,
  searchQuery,
  handleSearchChange,
  onSearch,
  viewMode,
  setViewMode,
  handleOpenCreateModal,
}) => {
  // Reusable HeaderButton component
  const HeaderButton = ({ type, label }) => (
    <button
      className={`border border-sss-blue-sel font-semibold rounded-md p-2 m-2 transition duration-300 ease-in-out ${
        selectedListType === type
          ? 'bg-sss-blue text-white'
          : 'text-sss-blue-sel hover:bg-sss-blue hover:text-white'
      }`}
      onClick={() => handleButtonClick(type)}
    >
      {label}
    </button>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim() === '') {
        onSearch('');
    } else {
        onSearch(searchQuery);
    }
};

  return (
    <div className="flex justify-between items-center mb-4">
      {/* List Type Buttons */}
      <div>
        <HeaderButton type="managementCompanies" label="Management Companies" />
        <HeaderButton type="customers" label="Customers" />
        <HeaderButton type="buildings" label="Buildings" />
        <HeaderButton type="allContacts" label="All Contacts" />
        <HeaderButton type="employees" label="Employees" />
        <HeaderButton type="vendors" label="Vendors" />
      </div>

      {/* Search Bar, Add Button, and View Mode Selector */}
      <div className="flex justify-end gap-4">
        {/* Search Bar */}
        <form
          onSubmit={handleSubmit}
          className="flex items-center border border-gray-300 rounded-lg overflow-hidden"
        >
          <button type="submit" className="px-3 py-2 text-gray-500 cursor-pointer border-r border-gray-300 bg-gray-50 hover:bg-gray-100 hover:text-sss-blue duration-500">
              <SearchIcon />
          </button>
          <input
            type="text"
            className="px-3 py-2 w-full outline-none"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </form>

        {/* Add Button */}
        <div>
          <button
            className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
            onClick={handleOpenCreateModal}
          >
            Add +
          </button>
        </div>

        {/* View Mode Selector */}
        <div>
          <label className="flex items-center">
            <select
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value)}
              className="px-2 py-2 border-2 border-sss-blue rounded-lg focus:border-sss-blue text-sss-blue-sel font-bold focus:outline-none"
              >
              <option value="table">Table View</option>
              <option value="card">Card View</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  );
};

ContactsHeader.propTypes = {
  selectedListType: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  viewMode: PropTypes.string.isRequired,
  setViewMode: PropTypes.func.isRequired,
  handleOpenCreateModal: PropTypes.func.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
};

export default ContactsHeader;
